import React from 'react';

const TabPanel = ({ tabs, activeTab, setActiveTab }) => {
  return (
    <div className="repaso-tabs">
      {tabs.map(tab => (
        <div 
          key={tab.id}
          className={`tab ${activeTab === tab.id ? "active" : ""}`}
          onClick={() => setActiveTab(tab.id)}
        >
          <i className={tab.icon}></i>
          <span>{tab.label}</span>
        </div>
      ))}
    </div>
  );
};

export default TabPanel;